import request from '@/utils/request'

// 获取登录验证码
export function getLoginCode(params) {
	return request({
		url: '/auth/create_code_t',
		method: 'get',
		// responseType: 'arraybuffer',
		params
	})
}

// 用户登录
export function studentLogin(data) {
	return request({
		url: '/auth/student_login',
		method: 'post',
		data
	})
}

// 用户登出
export function logout(data) {
	return request({
		url: '/auth/logout',
		method: 'post',
		data
	})
}
